/* usebundles theme behaviours: product gallery, variant price update, sticky add-to-cart bar. */
if (!window.ubThemeLoaded) {
window.ubThemeLoaded = true;
(() => {
  /* Product gallery: thumbnails switch the main media. */
  if (!customElements.get('ub-gallery')) {
    customElements.define('ub-gallery', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-ub-thumb]');
          if (!thumb) return;
          this.show(thumb.dataset.ubThumb);
        });
      }
      show(index) {
        this.querySelectorAll('[data-ub-slide]').forEach((slide) => {
          const active = slide.dataset.ubSlide === String(index);
          slide.hidden = !active;
          if (!active) slide.querySelectorAll('video').forEach((v) => v.pause());
        });
        this.querySelectorAll('[data-ub-thumb]').forEach((t) => {
          if (t.dataset.ubThumb === String(index)) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }
    });
  }

  /* Variant select: update every price row on the page and the button state. */
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ub-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    if (!option) return;
    document.querySelectorAll('[data-ub-price]').forEach((row) => {
      const now = row.querySelector('[data-ub-price-now]');
      const was = row.querySelector('[data-ub-price-was]');
      const save = row.querySelector('[data-ub-price-save]');
      if (now) now.textContent = option.dataset.price;
      if (was) { was.textContent = option.dataset.compare; was.hidden = !option.dataset.compare; }
      if (save) { save.textContent = option.dataset.save ? `You save ${option.dataset.save}` : ''; save.hidden = !option.dataset.save; }
    });
    const button = select.form && select.form.querySelector('[data-ub-add]');
    if (button) button.disabled = option.dataset.available !== 'true';
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url.toString());
  });

  /* Sticky bar: visible once the main add-to-cart has scrolled above the viewport. */
  if (!customElements.get('ub-sticky')) {
    customElements.define('ub-sticky', class extends HTMLElement {
      connectedCallback() {
        this.anchor = document.querySelector('[data-ub-sticky-anchor]');
        if (!this.anchor) return;
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.toggle(this.anchor.getBoundingClientRect().bottom < 0);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.body.classList.remove('ub-has-sticky');
      }
      toggle(show) {
        if (show === this.shown) return;
        this.shown = show;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.inert = !show;
        document.body.classList.toggle('ub-has-sticky', show);
      }
    });
  }
})();

/* ---------- Cart: AJAX add from product cards, cart page add/remove, collection filters ---------- */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cfg = window.ubTheme || {};

  const post = (url, body) =>
    fetch(`${root}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not update the cart.');
      return data;
    });

  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  const updateBubble = (sections) => {
    const html = sections && sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    const fresh = parse(html).querySelector('.shopify-section');
    if (fresh) bubble.innerHTML = fresh.innerHTML;
  };

  /* Toast shown after an add from a product card. */
  let toast;
  let toastTimer;
  const showToast = (message, isError) => {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ub-toast color-scheme-2';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.classList.toggle('ub-toast--error', Boolean(isError));
    toast.innerHTML = '';
    const text = document.createElement('p');
    text.className = 'ub-toast__text';
    text.textContent = message;
    toast.appendChild(text);
    if (!isError) {
      const actions = document.createElement('div');
      actions.className = 'ub-toast__actions';
      const view = document.createElement('a');
      view.href = `${root}cart`;
      view.className = 'ub-btn ub-btn--outline ub-btn--sm';
      view.textContent = 'View cart';
      const checkout = document.createElement('a');
      checkout.href = `${root}checkout`;
      checkout.className = 'ub-btn ub-btn--accent ub-btn--sm';
      checkout.textContent = 'Checkout';
      actions.append(view, checkout);
      toast.appendChild(actions);
    }
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ub-toast__close';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';
    close.addEventListener('click', () => toast.classList.remove('is-visible'));
    toast.appendChild(close);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 6000);
  };

  const setBusy = (button, busy, label) => {
    if (!button) return;
    if (busy) {
      button.dataset.label = button.textContent;
      button.textContent = label || 'Adding…';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    } else {
      button.textContent = label || button.dataset.label || button.textContent;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  /* Cart page: re-render the cart section from the response. */
  const cartEl = () => document.querySelector('[data-ub-cart]');
  const renderCart = (sections, message) => {
    const el = cartEl();
    if (!el || !sections) return window.location.reload();
    const html = sections[el.dataset.sectionId];
    if (!html) return window.location.reload();
    const fresh = parse(html).querySelector('[data-ub-cart]');
    if (fresh) el.replaceWith(fresh);
    updateBubble(sections);
    const status = document.querySelector('[data-ub-cart-status]');
    if (status && message) status.textContent = message;
  };
  const cartSections = () => {
    const el = cartEl();
    return { sections: [el.dataset.sectionId, 'cart-icon-bubble'], sections_url: window.location.pathname };
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.ub-btn-form');
    if (!form || !window.fetch) return;
    const inCart = form.closest('[data-ub-cart]');
    const onCard = form.closest('.ub-card, .ub-upsell');
    if (!inCart && !(onCard && cfg.cardAjax !== false)) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const id = Number(new FormData(form).get('id'));
    if (inCart) {
      setBusy(button, true);
      post('cart/add.js', { items: [{ id, quantity: 1 }], ...cartSections() })
        .then((data) => renderCart(data.sections, 'Added to cart'))
        .catch((err) => { setBusy(button, false); window.alert(err.message); });
      return;
    }
    setBusy(button, true);
    const title = (form.closest('.ub-card')?.querySelector('.ub-card__title')?.textContent || 'Item').trim();
    post('cart/add.js', { items: [{ id, quantity: 1 }], sections: ['cart-icon-bubble'], sections_url: window.location.pathname })
      .then((data) => {
        updateBubble(data.sections);
        setBusy(button, false, 'Added ✓');
        setTimeout(() => setBusy(button, false, button.dataset.label), 2000);
        showToast(`${title} added to your cart`);
        document.dispatchEvent(new CustomEvent('ub:cart:added', { detail: { id } }));
      })
      .catch((err) => { setBusy(button, false); showToast(err.message, true); });
  });

  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-ub-cart-remove]');
    if (!remove || !cartEl() || !window.fetch) return;
    event.preventDefault();
    remove.setAttribute('aria-busy', 'true');
    remove.textContent = 'Removing…';
    post('cart/change.js', { id: remove.dataset.ubCartRemove, quantity: 0, ...cartSections() })
      .then((data) => renderCart(data.sections, 'Item removed'))
      .catch((err) => window.alert(err.message));
  });

  document.addEventListener('change', (event) => {
    const qty = event.target.closest('[data-ub-cart-qty]');
    if (qty && cartEl()) {
      post('cart/change.js', { id: qty.dataset.ubCartQty, quantity: Math.max(0, Number(qty.value) || 0), ...cartSections() })
        .then((data) => renderCart(data.sections, 'Cart updated'))
        .catch((err) => window.alert(err.message));
      return;
    }
    /* Collection filters and sort submit on change. */
    const facets = event.target.closest('[data-ub-facets]');
    if (facets && (event.target.matches('[data-ub-autosubmit]') || event.target.type === 'checkbox')) {
      facets.requestSubmit ? facets.requestSubmit() : facets.submit();
    }
  });

  /* Filter dropdowns: one open at a time, close on outside click or Escape. */
  document.addEventListener('toggle', (event) => {
    const dd = event.target;
    if (!(dd instanceof HTMLDetailsElement) || !dd.matches('[data-ub-dd]') || !dd.open) return;
    document.querySelectorAll('[data-ub-dd][open]').forEach((other) => { if (other !== dd) other.open = false; });
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ub-dd]')) return;
    document.querySelectorAll('[data-ub-dd][open]').forEach((d) => { d.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-ub-dd][open]').forEach((d) => { d.open = false; d.querySelector('summary')?.focus(); });
  });
})();
}
